import { Record } from "immutable";

export type ContentStatType = {
  contentId?: string;
  timesStudied: number;
  timesTested: number;
  timesCorrect: number;
  timesIncorrect: number;
  timesGivenUp: number;
  lastStudied: string | null;
  lastContentModuleId: string | null;
  lastScore: number | null | undefined;
  averageScore: number | null | undefined;
  spacing: number | null | undefined;
};

export type OptionalContentStatType = Partial<ContentStatType>;

const defaultValues: ContentStatType = {
  contentId: undefined,
  timesStudied: 0,
  timesTested: 0,
  timesCorrect: 0,
  timesIncorrect: 0,
  timesGivenUp: 0,
  lastStudied: null,
  lastContentModuleId: null,
  lastScore: null,
  averageScore: null,
  spacing: null
};

export default class ContentStat extends Record(defaultValues) {}
